import { useCallback, useEffect, useRef, useState } from 'react'
import { shareCard } from '../lib/shareCard'
import { shareLabel, shareLingers, SHARE_SETTLE_MS } from '../lib/shareState'

// [label, share(opts), busy] — one share button's state machine. The button reads
// `label`, disables on `busy`, and calls share() with shareCard's options.
export function useShareCard() {
  const [state, setState] = useState('idle')
  const timer = useRef(null)
  useEffect(() => () => clearTimeout(timer.current), [])
  const share = useCallback(async (opts) => {
    if (state === 'rendering') return
    clearTimeout(timer.current)
    setState('rendering')
    const r = await shareCard(opts)
    setState(r)
    if (shareLingers(r)) timer.current = setTimeout(() => setState('idle'), SHARE_SETTLE_MS)
    else setState('idle')
    return r
  }, [state])
  return [shareLabel(state), share, state === 'rendering']
}
